import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { useParams } from "react-router-dom"
import { getGuideTrip, getCategories, getTripCategories } from "store/trips"
import { WizardProvider } from "./WizardProvider"
import { WizardLayout } from "./WizardLayout"

/**
 * New experience creation wizard.
 *
 * Architecture:
 *   - Single AntD Form instance shared across all steps via WizardContext
 *   - Step driven by ?step= query param (no per-step child routes)
 *   - Steps with non-form local state register save handlers in stepSaveHandlersRef
 *   - proNewListingForms Redux slice is NOT used here
 *
 * Route: /pro/home/experiences/:id/v2?step=<stepId>
 *
 * The old wizard at /pro/home/experiences/:id/wizard/* is untouched.
 * Both flows coexist for comparison and safe rollout.
 */
export const CreateExperience = () => {
  const dispatch = useDispatch()
  const { id } = useParams()

  useEffect(() => {
    if (id) {
      dispatch(getGuideTrip(id))
      dispatch(getCategories())
      dispatch(getTripCategories())
    }
  }, [dispatch, id])

  return (
    <WizardProvider tripId={id}>
      <WizardLayout />
    </WizardProvider>
  )
}
